export default __webpack_public_path__ + "static/list-style-image-md-cf360ac261cb2efe1e8e17276742b510.png";